<script setup lang="ts">
import SelectInput from '@/corePagesModule/SelectInput/SelectInput.vue';
import { i18n } from '@/i18n';
import { useOrderTableStore } from '@/orderTableModule/pages/useOrderTableStore';
import { storeToRefs } from 'pinia';
import { computed, onMounted } from 'vue';

const t = i18n.t;
const store = useOrderTableStore();
const { state } = storeToRefs(store);
const { fetchOrderGroup } = store;

const props = withDefaults(
  defineProps<{
    label?: string;
    indexNumber?: number;
    noFetch?: boolean;
    useUniqueModelValue?: boolean;
    propModelValue?: string;
  }>(),
  {
    label: undefined,
    indexNumber: 0,
    propModelValue: undefined,
  }
);
const emits = defineEmits<{ (e: 'change', name: string) }>();

const groupListNames = computed(() =>
  state.value.orderGroupState.groupList.map((group) => group.orderGroupName).filter((groupName) => groupName)
);

const label = computed(() => props.label ?? t('発注グループ名'));

const modelValue = computed(() => props.propModelValue ?? state.value.orderGroupState.targetGroupName);

onMounted(async () => {
  if (!props.noFetch) await fetchOrderGroup();
});
</script>
<template>
  <SelectInput
    :index="indexNumber"
    :model-value="modelValue"
    :placeholder="label"
    :label="label"
    filter-type="ORDER_GROUP"
    :prop-options="groupListNames"
    use-teleport
    :use-search-input="false"
    :use-reset="false"
    @update:model-value="
      (val) => {
        if (!useUniqueModelValue) state.orderGroupState.targetGroupName = val;
        emits('change', val);
      }
    "
  />
</template>
